// Pretty labels for scanner modules + vuln-scan profiles. Anything not in
// the map falls through to a snake_case -> Title Case conversion so a brand
// new scanner still renders decently.

const LABELS = {
  subdomain_enum: 'Subdomain Enumeration',
  dns_probe: 'DNS Probe',
  http_probe: 'HTTP Probe',
  tls_check: 'TLS Check',
  headers_check: 'HTTP Headers',
  tech_fingerprint: 'Tech Fingerprint',
  wappalyzer_scan: 'Tech Fingerprint',
  shodan_scan: 'Shodan',
  port_scan: 'Port Scan',
  nmap_scan: 'Port Scan',
  web_crawler: 'Web Crawler',
  dir_bruteforce: 'Directory Brute Force',
  nuclei_scan: 'Nuclei',
  passive_capture: 'Passive Capture',
};

function titleCase(s) {
  return String(s)
    .split(/[_-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function moduleLabel(name) {
  if (!name) return '';
  if (LABELS[name]) return LABELS[name];
  return titleCase(name);
}
